export const uploadableExtensions = ['.jpg', '.png', '.jpeg', '.pdf', '.docx', '.txt', '.csv', '.xlsx'];


export function acceptedUploadTypes() {
  return uploadableExtensions;
}


export const fileHasUploadableExtension = (file: File) => {
  const fileExtension = `.${file.name.split('.').pop()}`.toLowerCase();
  return uploadableExtensions.some(ext => ext.toLowerCase() === fileExtension);
};
